export const TYPE_COMMON = {
    TYPE_COMPANY : "company",
    TYPE_COMPANIES : "companies",
    TYPE_TENANT: "tenant",
    TYPE_TENANTS: "tenants",
    TYPE_PROPERTY: "property",
    TYPE_PROPERTIES: "properties",
}